import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { validateIsNotempty, validateCharecters, validateNumber, validateEmail } from '../../utils';

function EditprofileDialog(props)
{
	const { data, handleSave } = props;
	const [ formData, setFormData ] = useState({ fname: '', lname: '', email: '', teamName: '', companyName: '' });
	const [ errorObj, setError ] = useState({});

	const handleChange = (val, name) =>
	{
		setFormData((prevState) => { return { ...prevState, [name]: val }; });
	};

	useEffect(() =>
	{
		if (data && data !== null)
		{
			setFormData(data);
		}
	}, [ data ]);

	const handleSubmit = () =>
	{
		const { fname, lname, email, phone, teamName, companyName } = formData;

		// eslint-disable-next-line quotes, no-console
		// console.log("formData ==== ", formData);
		const error = {};

		if (!validateIsNotempty(fname))
		{
			error['fname'] = 'Please Enter First Name';
		}
		else if (!validateCharecters(fname))
		{
			error['fname'] = 'Please Enter valid First Name';
		}
		if (lname !== '' && !validateCharecters(lname))
		{
			error['lname'] = 'Please Enter valid Last Name';
		}
		if (!validateIsNotempty(email))
		{
			error['email'] = 'Please Enter Email';
		}
		else if (!validateEmail(email))
		{
			error['email'] = 'Please Enter valid Email';
		}
		if (phone !== '' && !validateNumber(phone))
		{
			error['phone'] = 'Please Enter valid Phone Number';
		}
		if (teamName !== '' && !validateCharecters(teamName))
		{
			error['teamName'] = 'Please Enter valid Team Name';
		}
		if (companyName !== '' && !validateCharecters(companyName))
		{
			error['companyName'] = 'Please Enter valid Company Name';
		}
		// eslint-disable-next-line quotes, no-console
		// console.log('error ==== ', error);
		if (Object.keys(error).length <= 0)
		{
			setError({});
			const body = {
				fname,
				lname,
				email,
				phone,
				teamName,
				companyName
			};

			handleSave(body);
		}
		else
		{
			setError(error);
		}
	};

	return (
		<Dialog
			open={props?.editprofileOpen}
			onClose={props?.handleClose}
			aria-labelledby='alert-dialog-title'
		>
			<DialogTitle id='scroll-dialog-title' className='dialogTitleBlock'>
				<div className='flexRow alignCntr'>
					<div className='flexMinWidthCol'>
						<h3>Edit Personal Details</h3>
					</div>
					<div className='flexAutoCol'>
						<IconButton aria-label='Close' onClick={props?.handleClose}>
							<CloseRoundedIcon />
						</IconButton>
					</div>
				</div>
			</DialogTitle>
			<DialogContent>
				<div className='flexCol'>
					<TextField
						label='First Name'
						margin='dense'
						fullWidth
						variant='standard'
						id='fname'
						onChange={(e) => handleChange(e.target.value, 'fname')}
						value={formData?.fname ? formData.fname : ''}
						error={errorObj?.fname ? true : false}
						helperText={errorObj?.fname}
					/>
					<TextField
						label='Last Name'
						margin='dense'
						fullWidth
						variant='standard'
						id='lname'
						onChange={(e) => handleChange(e.target.value, 'lname')}
						value={formData?.lname ? formData.lname : ''}
						error={errorObj?.lname ? true : false}
						helperText={errorObj?.lname}
					/>
					<TextField
						label='Email'
						margin='dense'
						fullWidth
						variant='standard'
						id='email'
						onChange={(e) => handleChange(e.target.value, 'email')}
						value={formData?.email ? formData.email : ''}
						error={errorObj?.email ? true : false}
						helperText={errorObj?.email}
					/>
					<TextField
						label='Phone Number'
						margin='dense'
						fullWidth
						variant='standard'
						id='phone'
						onChange={(e) => handleChange(e.target.value, 'phone')}
						value={formData?.phone ? formData.phone : ''}
						error={errorObj?.phone ? true : false}
						helperText={errorObj?.phone}
					/>
					<TextField
						label='Team Name'
						margin='dense'
						fullWidth
						variant='standard'
						id='teamName'
						onChange={(e) => handleChange(e.target.value, 'teamName')}
						value={formData?.teamName ? formData.teamName : ''}
						error={errorObj?.teamName ? true : false}
						helperText={errorObj?.teamName}
					/>
					<TextField
						label='Company Name'
						margin='dense'
						fullWidth
						variant='standard'
						id='companyName'
						onChange={(e) => handleChange(e.target.value, 'companyName')}
						value={formData?.companyName ? formData.companyName : ''}
						error={errorObj?.companyName ? true : false}
						helperText={errorObj?.companyName}
					/>
				</div>
			</DialogContent>
			<DialogActions className='dialogFooterBlock'>
				<Button color='primary' onClick={props?.handleClose}>
					cancel
				</Button>
				<Button onClick={handleSubmit}>
					save
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default EditprofileDialog;
